const getDomainForCookie = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('medibuddy.in')) {
    return '.medibuddy.in';
  }
  return hostname;
};

export const setCookie = (name, value) => {
  try {
    if (!value) return;
    const domain = getDomainForCookie();
    document.cookie = `${name}=${String(value)}; path=/; domain=${domain}; SameSite=strict`;
  } catch (error) {
    console.error(`Error setting cookie ${name}:`, error);
  }
};

export const deleteCookie = (name) => {
  try {
    const domain = getDomainForCookie();
    // delete from root domain
    document.cookie = `${name}=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=strict`;
    // also delete from subdomain (cleanup old cookies)
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=strict`;
  } catch (error) {
    console.error(`Error deleting cookie ${name}:`, error);
  }
};

export const getCookie = (name) => {
  try {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  } catch (error) {
    console.error(`Error getting cookie ${name}:`, error);
    return null;
  }
};


export const getRedirectToken = () => {
  return getCookie("redirect");
};

export const setRedirectToken = (value) => {
  setCookie("redirect", value);
};

export const getMbServerToken = () => {
  return getCookie("mbServerToken");
};

export const setMbServerToken = (value) => {
  setCookie("mbServerToken", value);
};

export const clearAuthTokens = () => {
  deleteCookie("redirect");
  deleteCookie("mbServerToken");
};

export const getAuthTokens = () => {
  return {
    redirect: getRedirectToken(),
    mbServerToken: getMbServerToken(),
  };
};
